import { toast } from "react-toastify";
import { cancelPayrollRun } from "features/Payroll/services/PayrollService";

export async function cancelPayrollRunWithFeedback(
  runId: number,
  reason?: string,
): Promise<{ ok: boolean; message: string }> {
  try {
    const res = await cancelPayrollRun(runId, reason);
    if (res.success) {
      return { ok: true, message: res.message || "Payroll run cancelled" };
    }
    toast.error(res.message || "Could not cancel run");
    return { ok: false, message: "" };
  } catch (err: unknown) {
    const msg = (err as { response?: { data?: { message?: string } } })
      ?.response?.data?.message;
    toast.error(msg || "Could not cancel run");
    return { ok: false, message: "" };
  }
}
